import React, {forwardRef, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {composerDetailsTokenBoxStyle} from '../../../../../libs/shared/ui/src/styles/composerStyles';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface TokenBaseProps {
  isSelected?: boolean;
  children?: ReactNode;
}

/*
 * Style.
 */

interface TokenBaseStyleProps {
  $isSelected?: boolean;
}
const StyledTokenDiv = styled.div<TokenBaseStyleProps>`
  -webkit-user-select: none;
  user-select: none;

  ${composerDetailsTokenBoxStyle};
  padding-left: 6px;
  padding-right: 6px;
  margin-right: 4px;

  border-radius: 4px;
  background-color: ${(p) => p.theme.palette.blue.shade20};

  color: ${(p) => p.theme.interactiveText};
  font-weight: ${fontWeights.medium};

  ${(p) => addColorStyles(p)};
`;

function addColorStyles(props: TokenBaseStyleProps) {
  if (props.$isSelected) {
    return css`
      color: ${(p) => p.theme.greys.white};
      background-color: ${(p) => p.theme.palette.blue.shade40};
    `;
  }

  return css`
    &:hover {
      color: ${(p) => p.theme.interactiveTextHover};
      background-color: ${(p) => p.theme.palette.blue.shade30};
    }
  `;
}

/*
 * Component.
 */

export const TokenBase = forwardRef<HTMLDivElement, TokenBaseProps>((props, ref) => (
  <StyledTokenDiv ref={ref} $isSelected={props.isSelected}>
    {props.children}
  </StyledTokenDiv>
));
